// 聊天配置
const chatConfig = {
    token: 'pat_faIaucPWcj89UXa8DEeavkWzWqWwmOZcBKT5trv49mQw1PCvmvCPrk3OGT9nrRuz',
    botId: '7477750339362963466'
};

// 从localStorage获取聊天记录
const getChatHistoryFromStorage = () => {
    const chatHistory = localStorage.getItem('nixiaofeng_chat_history');
    return chatHistory ? JSON.parse(chatHistory) : [];
};

// 保存聊天记录到localStorage
const saveChatHistoryToStorage = (messages) => {
    localStorage.setItem('nixiaofeng_chat_history', JSON.stringify(messages));
};

// 从localStorage获取对话信息
const getConversationFromStorage = () => {
    const conversation = localStorage.getItem('nixiaofeng_chat_conversation');
    return conversation ? JSON.parse(conversation) : { id: null, createdAt: null };
};

// 保存对话信息到localStorage
const saveConversationToStorage = (id, createdAt) => {
    localStorage.setItem('nixiaofeng_chat_conversation', JSON.stringify({ id, createdAt }));
};

// 清除对话信息
const clearConversationFromStorage = () => {
    localStorage.removeItem('nixiaofeng_chat_conversation');
};

// 从localStorage获取用户ID
const getUserIdFromStorage = () => {
    const userId = localStorage.getItem('nixiaofeng_chat_user_id');
    return userId || null;
};

// 保存用户ID到localStorage
const saveUserIdToStorage = (userId) => {
    localStorage.setItem('nixiaofeng_chat_user_id', userId);
};

// 清除用户ID
const clearUserIdFromStorage = () => {
    localStorage.removeItem('nixiaofeng_chat_user_id');
};

const state = {
    messages: getChatHistoryFromStorage(),
    isMinimized: true,
    isGenerating: false,
    userId: getUserIdFromStorage(),
    ...getConversationFromStorage()  // 初始化时从localStorage获取对话信息
};

const mutations = {
    ADD_MESSAGE(state, message) {
        message.timestamp = Date.now();
        state.messages.push(message);
        saveChatHistoryToStorage(state.messages);
    },
    UPDATE_LAST_MESSAGE(state, { content, displayContent }) {
        if (state.messages.length > 0) {
            const lastMessage = state.messages[state.messages.length - 1];
            lastMessage.content = content;
            if (displayContent !== undefined) {
                lastMessage.displayContent = displayContent;
            }
            lastMessage.timestamp = Date.now();
            saveChatHistoryToStorage(state.messages);
        }
    },
    REMOVE_THINKING_MESSAGE(state) {
        state.messages = state.messages.filter(msg => msg.type !== 'thinking');
        saveChatHistoryToStorage(state.messages);
    },
    CLEAR_HISTORY(state) {
        state.messages = [];
        localStorage.removeItem('nixiaofeng_chat_history');
    },
    SET_MINIMIZED(state, value) {
        state.isMinimized = value;
    },
    SET_GENERATING(state, value) {
        state.isGenerating = value;
    },
    CANCEL_GENERATION(state) {
        state.isGenerating = false;
        // 移除思考中的消息
        state.messages = state.messages.filter(msg => msg.type !== 'thinking');
        // 如果最后一条消息是系统消息且正在打字，则标记为已完成
        if (state.messages.length > 0) {
            const lastMessage = state.messages[state.messages.length - 1];
            if (lastMessage.type === 'system' && lastMessage.isTyping) {
                lastMessage.isTyping = false;
                lastMessage.displayContent = lastMessage.content;
            }
        }
        saveChatHistoryToStorage(state.messages);
    },
    SET_CONVERSATION_INFO(state, { id, createdAt }) {
        state.id = id;
        state.createdAt = createdAt;
        saveConversationToStorage(id, createdAt);
    },
    CLEAR_CONVERSATION_INFO(state) {
        state.id = null;
        state.createdAt = null;
        clearConversationFromStorage();
    },
    SET_USER_ID(state, userId) {
        state.userId = userId;
        saveUserIdToStorage(userId);
    },
    CLEAR_USER_ID(state) {
        state.userId = null;
        clearUserIdFromStorage();
    }
};

const actions = {
    addMessage({ commit }, message) {
        commit('ADD_MESSAGE', message);
    },
    updateLastMessage({ commit }, payload) {
        commit('UPDATE_LAST_MESSAGE', payload);
    },
    removeThinkingMessage({ commit }) {
        commit('REMOVE_THINKING_MESSAGE');
    },
    clearHistory({ commit }) {
        commit('CLEAR_HISTORY');
        commit('CLEAR_CONVERSATION_INFO');  // 清除历史记录时也清除对话信息
    },
    setMinimized({ commit }, value) {
        commit('SET_MINIMIZED', value);
    },
    setGenerating({ commit }, value) {
        commit('SET_GENERATING', value);
    },
    cancelGeneration({ commit }) {
        commit('CANCEL_GENERATION');
    },
    setConversationInfo({ commit }, conversationInfo) {
        commit('SET_CONVERSATION_INFO', conversationInfo);
    },
    clearConversationInfo({ commit }) {
        commit('CLEAR_CONVERSATION_INFO');
    },
    setUserId({ commit }, userId) {
        commit('SET_USER_ID', userId);
    },
    clearUserId({ commit }) {
        commit('CLEAR_USER_ID');
    }
};

const getters = {
    getChatMessages: state => state.messages,
    getIsMinimized: state => state.isMinimized,
    getIsGenerating: state => state.isGenerating,
    getConversationId: state => state.id,
    getConversationCreatedAt: state => state.createdAt,
    getUserId: state => state.userId,
    getChatConfig: () => chatConfig
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}; 